import { render, staticRenderFns } from "./ZhejiangTelecom1.vue?vue&type=template&id=38f6a5c0&scoped=true"
import script from "./ZhejiangTelecom1.vue?vue&type=script&lang=js"
export * from "./ZhejiangTelecom1.vue?vue&type=script&lang=js"
import style0 from "./ZhejiangTelecom1.vue?vue&type=style&index=0&id=38f6a5c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f6a5c0",
  null
  
)

export default component.exports